import { Link } from "@tanstack/react-router";
import { HomeOutlined } from "@ant-design/icons";
import type { NavItemType } from "../layout/NavItemType.ts";

export const navItem: NavItemType = {
  key: "/",
  label: <Link tabIndex={0} to={"/"}>Home</Link>,
  icon: <HomeOutlined />,
  order: 1,
};
